import { colors, themes } from '../constants';
import { defaultShadows } from './shadows';

export default {
    name: themes.light,
    palette: {
      /**
       * Pallete consist of PalletteColors. Default PaletteColors: 
       * primary, secondary, error, warning, info, success
       * 
       * PaletteColor {
       *    light?: string;
       *    main: string;
       *    dark?: string;
       *    contrastText?: string;
       * }
       */
      primary: {
        main: colors.wobo,
        light: colors.white
      },
      secondary: {
        main: colors.white,
        dark: 'rgb(100,163,189)'
      }
    },
    shadows: defaultShadows
  }